import Vue from "vue";
import Vuex from "vuex";
import VuexPersist from "vuex-persist";
import localForage from "localforage";
import VueSwal from "vue-swal";

import auth from "./store/auth";
import messages from "./store/messages";

Vue.use(VueSwal);
Vue.use(Vuex);

const vuexStorage = new VuexPersist({
  key: process.env.VUE_APP_STORAGE_KEY,
  storage: localForage
});

export default new Vuex.Store({
  modules: {
    auth,
    messages
  },
  plugins: [vuexStorage.plugin]
});
